export default __webpack_public_path__ + "static/media/diagnostics.890fab0d.svg";